import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { ContactUsDTO } from '../../../api/contact-us-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T, translate } from '../../../components/basic/text';

interface SaveContactUsModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedContactUs?: ContactUsDTO;
    onHide: () => void;
    onSave: (values: ContactUsDTO) => void;
    onDelete?: (contactUs: ContactUsDTO) => void;
}

export function SaveContactUsModal({
    show,
    allowEdit,
    selectedContactUs,
    onHide,
    onSave,
    onDelete,
}: SaveContactUsModalProps) {
    const defaultValues: ContactUsDTO = {
        id: selectedContactUs?.id,

        username: selectedContactUs ? selectedContactUs.username : '',
        phone: selectedContactUs ? selectedContactUs.phone : '',
        email: selectedContactUs ? selectedContactUs.email : '',
        subject: selectedContactUs ? selectedContactUs.subject : '',
        message: selectedContactUs ? selectedContactUs.message : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedContactUs ? 'edit-contact-us' : 'new-contact-us'}</T>
                            <bd.Flex align="center" gap={2}>
                                {selectedContactUs && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedContactUs)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            {formik.values.phone && (
                                <bd.FormRow label={translate('phone')} className="flex-grow-1">
                                    <div className="border border-1 w-100 rounded p-2 text-muted">
                                        {formik.values.phone}
                                    </div>
                                </bd.FormRow>
                            )}
                            {formik.values.email && (
                                <bd.FormRow label={translate('email')}>
                                    <div className="border border-1 rounded p-2 text-muted">
                                        {formik.values.email}
                                    </div>
                                </bd.FormRow>
                            )}
                        </bd.Flex>

                        <bd.Flex vertical gap={2}>
                            <bd.FormRow label={translate('subject')}>
                                <div className="border border-1 w-100 rounded p-2 text-muted">
                                    {formik.values.subject}
                                </div>
                            </bd.FormRow>
                            <bd.FormRow label={translate('message')}>
                                <div className="border border-1 w-100 pre-wrap rounded p-2 text-muted">
                                    {formik.values.message}
                                </div>
                            </bd.FormRow>
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
